import { FC } from "react";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  BarChart,
  Bar,
} from "recharts";
import { primaryColor } from "../../../utils/colors";
import { IndicatorHistory } from "../../../types/Indicator/IndicatorDataReport/IndicatorHistory";

interface BarGraphProps {
  data: IndicatorHistory[] | { monthYear: string; value: number }[];
  width: string | number;
  height: string | number;
  barName: string;
  dataProcesed?: boolean;
}

const BarGraph: FC<BarGraphProps> = ({
  data,
  width,
  height,
  barName,
  dataProcesed = false,
}) => {
  const processedData = !dataProcesed
    ? (data as IndicatorHistory[])
        .slice(1)
        .reverse()
        .flatMap((item) =>
          item.datas
            .filter((dataItem) => dataItem.value !== null)
            .map((dataItem) => ({
              monthYear: dataItem.dataPeriod
                ? `${dataItem.dataPeriod.name.slice(0, 3)} ${dataItem.year}`
                : `${dataItem.year}`,
              value: dataItem.value,
            })),
        )
    : (data as { monthYear: string; value: number }[]);

  const uniqueData = processedData.filter(
    (item, index, self) =>
      index === self.findIndex((t) => t.monthYear === item.monthYear),
  );

  return (
    <ResponsiveContainer width={width} height={height}>
      <BarChart data={uniqueData} margin={{ left: 10 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="monthYear"
          scale="point"
          stroke={primaryColor}
          strokeWidth="2px"
          angle={-30}
          textAnchor="end"
          padding={{ left: 20, right: 20 }}
        />
        <YAxis stroke={primaryColor} strokeWidth="2px" width={20} />
        <Tooltip />
        <Legend
          layout="horizontal"
          align="left"
          verticalAlign="bottom"
          wrapperStyle={{ paddingTop: 25, marginLeft: 20 }}
        />
        <Bar dataKey="value" fill={primaryColor} name={barName} barSize={20} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BarGraph;
